import React from "react";
import { Chip, TableCell } from "@mui/material";

import {
  HubHookFormInput,
  UsersHookFormSelect,
} from "../../components";
import { StyledHubHookFormDatePicker, StyledTableRow } from "./styles";
import LaborContextMenu from "./LaborContextMenu";

const LaborStatus = ({ reworked, endDate }) => {
  let flow = reworked ? "grey" : endDate ? "blue" : "green";
  let label = reworked ? "Reworked" : endDate ? "Complete" : "Started";
  return <Chip variant="colorTag" label={label} flow={flow} />;
};

const LaborTableRow = ({
  prefix = "",
  labor = {},
  disabled = false,
  onFieldUpdate = () => {},
  setDeletingId = () => {},
  showHeatCode = true,
  showContextMenuColumn = true,
}) => {
  const handleOnFieldUpdate = () => onFieldUpdate(prefix);
  const finalDisabled = disabled || labor?.deleted;

  return (
    <StyledTableRow key={prefix}>
      <TableCell variant="small" disabled={finalDisabled}>
        <LaborStatus {...labor} />
      </TableCell>
      <TableCell sx={{ width: 200 }}>
        <UsersHookFormSelect
          name={prefix + ".userId"}
          defaultValue={labor?.userId}
          locationId={labor?.locationId}
          onChange={handleOnFieldUpdate}
          disabled={finalDisabled}
          rendered={false}
          hideLabel
        />
      </TableCell>
      <TableCell sx={{ width: 100, minWidth: 100 }} disabled={finalDisabled}>
        <HubHookFormInput
          name={prefix + ".completed"}
          placeholder="Completed"
          defaultValue={labor.completed || "0"}
          onBlur={handleOnFieldUpdate}
          disabled={finalDisabled}
          required
        />
      </TableCell>
      <TableCell sx={{ width: 100, minWidth: 100 }} disabled={finalDisabled}>
        <HubHookFormInput
          name={prefix + ".scrapped"}
          placeholder="Scrapped"
          defaultValue={labor.scrapped || "0"}
          onBlur={handleOnFieldUpdate}
          disabled={finalDisabled}
          required
        />
      </TableCell>
      <TableCell sx={{ width: 100, minWidth: 100 }} disabled={finalDisabled}>
        <StyledHubHookFormDatePicker
          name={prefix + ".startDate"}
          placeholder="MM/DD/YYYY HH:MM"
          defaultValue={labor?.startDate}
          onChange={handleOnFieldUpdate}
          disabled={finalDisabled}
          includeTime
          required
        />
      </TableCell>
      <TableCell sx={{ width: 100, minWidth: 100 }} disabled={finalDisabled}>
        <StyledHubHookFormDatePicker
          name={prefix + ".endDate"}
          placeholder="MM/DD/YYYY HH:MM"
          defaultValue={labor?.endDate}
          onChange={handleOnFieldUpdate}
          disabled={finalDisabled}
          includeTime
          required
        />
      </TableCell>
      {showHeatCode && (
        <TableCell sx={{ width: 150, minWidth: 150 }} disabled={finalDisabled}>
          <HubHookFormInput
            name={prefix + ".heatCode"}
            placeholder="Heat Code"
            defaultValue={labor.heatCode}
            onBlur={handleOnFieldUpdate}
            disabled={finalDisabled}
          />
        </TableCell>
      )}
      <TableCell disabled={finalDisabled}>
        <HubHookFormInput
          name={prefix + ".notes"}
          placeholder="Notes"
          defaultValue={labor.notes}
          onBlur={handleOnFieldUpdate}
          disabled={finalDisabled}
          disableHelperText
        />
        <HubHookFormInput
          name={prefix + ".laborId"}
          defaultValue={labor.laborId}
          hidden
        />
      </TableCell>
      {showContextMenuColumn && (
        <TableCell variant="small" disabled={finalDisabled}>
          <LaborContextMenu
            id={labor.laborId}
            setDeletingId={setDeletingId}
            disabled={finalDisabled || disabled}
          />
        </TableCell>
      )}
    </StyledTableRow>
  );
};

export default LaborTableRow;
